<template>
  <div ref="page" class="task-page" :class="{ 'task-page--mobile': isMobile }">
    <div class="task-page__card">
      <task-form
        :key="$route.fullPath"
        :ref-item="$route.params.refItem"
        :ref-type="$route.params.refType"
        :copy="$route.params.copy"
        @close="leave"
      />
    </div>
  </div>
</template>

<script>
// Full-page task create/edit (/task/index, /task/edit/:id) using the
// redesigned TaskForm. The legacy pages/task/task.vue is left untouched.
// TaskForm reads the task id from $route.params.id itself (as task.vue did).
import TaskForm from './components/TaskForm'

export default {
  name: 'TaskPage',
  components: { TaskForm },
  mounted () {
    this.measureSoon()
    window.addEventListener('resize', this.measure)
  },
  activated () {
    this.measureSoon()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.measure)
  },
  methods: {
    measureSoon () {
      this.measure()
      setTimeout(this.measure, 350)
    },
    // Fill the viewport below the app bar; the form scrolls inside.
    measure () {
      const el = this.$refs.page
      if (!el) return
      const top = el.getBoundingClientRect().top
      const gap = this.isMobile ? 0 : 8
      el.style.height = Math.max(420, window.innerHeight - top - gap) + 'px'
    },
    // Close / saved: go back where the user came from, else to the task list.
    leave () {
      if (window.history.length > 1) this.$router.back()
      else this.$router.push({ name: 'TaskList' })
    },
  },
}
</script>

<style scoped>
.task-page {
  display: flex;
  flex-direction: column;
  min-height: 0;
  margin: 4px 0 0;
  padding: 12px 14px;
  background: #f3f5f9;
  border-radius: 6px;
}
.theme--dark .task-page {
  background: #121212;
}
.task-page--mobile {
  margin: 0;
  padding: 0;
  border-radius: 0;
}
.task-page__card {
  flex: 1 1 auto;
  min-height: 0;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  border: 1px solid #e6e9ef;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
}
.theme--dark .task-page__card {
  background: #1e1e1e;
  border-color: #333;
}
.task-page--mobile .task-page__card {
  border: 0;
  border-radius: 0;
}
.task-page ::v-deep .v-input {
  height: auto !important;
}
</style>
